module.exports = __webpack_public_path__ + "static/media/qr-scanner_p2_1.701fcd57.png";